import { createGetAllAPI, createGetAPI, createPostAPI } from '@cuemath/rest-api';
import { stringify } from 'query-string';
import { BASE_URL } from 'constants/api';

const EVAL_SPECIALISTS_URL = `${BASE_URL}/students/eval-specialists`;
const EVALS_URL = `${BASE_URL}/students/evals`;

const { useGetAll: useGetAllEvalSpecialistRoster } = createGetAllAPI({
  getURL: query => `${EVAL_SPECIALISTS_URL}/roster/?${stringify(query || {})}`,
});

const { useGetAll: useGetAllEvalSpecialistAvailability } = createGetAllAPI({
  getURL: query => `${EVAL_SPECIALISTS_URL}/availability/?${stringify(query || {})}`,
});

const { useGetAll: useGetAllEvalSpecialistCapacity } = createGetAllAPI({
  getURL: query => `${EVAL_SPECIALISTS_URL}/capacity/?${stringify(query || {})}`,
});

const { useGetAll: useGetAllEvals } = createGetAllAPI({
  getURL: query => `${EVALS_URL}/?${stringify(query || {})}`,
});

const { useGet: useGetEvalSpecialistSlots } = createGetAPI({
  getURL: (teacherId, query = {}) =>
    `${EVAL_SPECIALISTS_URL}/${teacherId}/slots/?${stringify(query)}`,
});

const { usePost: usePostEvalSpecialistPause } = createPostAPI({
  getURL: (_, teacherId) => `${EVAL_SPECIALISTS_URL}/${teacherId}/pause/`,
});

const { usePost: usePostEvalSpecialistPauseCancel } = createPostAPI({
  getURL: (_, teacherId) => `${EVAL_SPECIALISTS_URL}/${teacherId}/pause/cancel/`,
});

export {
  useGetAllEvalSpecialistAvailability,
  useGetAllEvalSpecialistRoster,
  useGetAllEvalSpecialistCapacity,
  useGetAllEvals,
  useGetEvalSpecialistSlots,
  usePostEvalSpecialistPause,
  usePostEvalSpecialistPauseCancel,
};
